const metaValue = name => document.querySelector(`meta[name="${name}"]`)?.content
const submitButton = el => el.closest("form").querySelector('input[type="submit"]')

export {
  metaValue,
  submitButton
}
